// Login view — redirects to OIDC or shows error

import { useEffect } from "react";

export function Login() {
	const params = new URLSearchParams(window.location.search);
	const error = params.get("error");

	useEffect(() => {
		// Auto-redirect to OIDC if no error
		if (!error) {
			window.location.href = "/auth/login";
		}
	}, [error]);

	return (
		<div
			style={{
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				minHeight: "100vh",
				background: "var(--color-bg)",
			}}
		>
			<div className="card" style={{ maxWidth: "400px", textAlign: "center" }}>
				<h1 style={{ fontSize: "var(--text-xl)", marginBottom: "var(--space-4)" }}>
					WireGuard Manager
				</h1>

				{error ? (
					<>
						<p style={{ color: "var(--color-error)", marginBottom: "var(--space-4)" }}>
							Authentication failed: {error}
						</p>
						<a className="btn btn-primary" href="/auth/login">
							Try Again
						</a>
					</>
				) : (
					<p style={{ color: "var(--color-ink-muted)" }}>Redirecting to login...</p>
				)}
			</div>
		</div>
	);
}
